/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React, { useEffect, useState } from "react";
import fetchHelper from "../../services/fetchHelper";
import LocationsTable from "./LocationsTable";
import useError from "../../hooks/useError";

export const Loading = ({ length = 15, colspan = 12 }) => {
  const array = new Array(length);
  array.fill(1);
  return array.map((item, index) => (
    <tbody key={index}>
      <tr>
        <td colSpan={colspan}></td>
      </tr>
      <tr>
        <td colSpan={colspan} style={{ background: "#fff", padding: 0 }}>
          <img src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTUwNSA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KLnJlY3QgewpmaWxsOiB1cmwoI2xpbmVhci1ncmFkaWVudCk7Cn0KPC9zdHlsZT4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0ibGluZWFyLWdyYWRpZW50Ij4KPHN0b3Agb2Zmc2V0PSIwJSIgc3RvcC1jb2xvcj0iI0Y3RjdGNyIgLz4KPHN0b3Agb2Zmc2V0PSIzMyUiIHN0b3AtY29sb3I9IiNGN0Y3RjciIC8+CjxzdG9wIG9mZnNldD0iNTAlIiBzdG9wLWNvbG9yPSIjZWZmMGYwIiAvPgo8c3RvcCBvZmZzZXQ9IjY3JSIgc3RvcC1jb2xvcj0iI0Y3RjdGNyIgLz4KPHN0b3Agb2Zmc2V0PSIxMDAlIiBzdG9wLWNvbG9yPSIjRjdGN0Y3IiAvPgo8YW5pbWF0ZVRyYW5zZm9ybSBhdHRyaWJ1dGVOYW1lPSJncmFkaWVudFRyYW5zZm9ybSIKdHlwZT0idHJhbnNsYXRlIgpmcm9tPSItMSAwIgp0bz0iMSAwIgpiZWdpbj0iMHMiCmR1cj0iMS41cyIKcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgoKPHJlY3QgY2xhc3M9InJlY3QiIHg9IjAuOTgyOTEiIHk9IjAuMTY3NDgiIHdpZHRoPSIxNTAzLjE1IiBoZWlnaHQ9IjQ0LjgzMjUiIHJ4PSI2IiBmaWxsPSIjZWZmMGYwIi8+CjxyZWN0IGNsYXNzPSJyZWN0IiB4PSIwLjk4MjkxIiB5PSIwLjE2NzQ4IiB3aWR0aD0iMTUwMy4xNSIgaGVpZ2h0PSI0NC44MzI1IiByeD0iNiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyKSIvPgo8L3N2Zz4=" />
        </td>
      </tr>
    </tbody>
  ));
};

const AllReports = () => {
  const showDefaultApiError = useError();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const data = await fetchHelper.get({
        url: `patientmanagement/rest/location`,
      });
      setData(data);
    } catch (err) {
      showDefaultApiError(err);
      setData([]);
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return <LocationsTable data={data} initialLoad={isLoading} />;
};

export default AllReports;
